import { PartnerCards } from "./PartnerCards";

export type { PartnerCardsProps } from "./PartnerCards.d";
export { PartnerCards };
